import React, { useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
interface BeforeAfterSliderProps {
  before: string;
  after: string;
  beforeLabel: string;
  afterLabel: string;
  alt: string;
  ariaLabel: string;
}
export function BeforeAfterSlider({
  before,
  after,
  beforeLabel,
  afterLabel,
  alt,
  ariaLabel
}: BeforeAfterSliderProps) {
  const [position, setPosition] = useState(50);
  return <div className="relative select-none overflow-hidden rounded-2xl bg-navy" data-id="element-36" data-mp="3d0x4goteq1kr">
      <img src={after} alt={`${alt} — ${afterLabel}`} loading="lazy" className="block w-full" data-id="element-37" data-mp="382vl02s2k08r" />
      <div className="absolute inset-0" style={{
      clipPath: `inset(0 ${100 - position}% 0 0)`
    }} aria-hidden="true" data-id="element-38" data-mp="3m13fm41mupgr">
        <img src={before} alt="" loading="lazy" className="h-full w-full object-cover" data-id="element-39" data-mp="1rodkxk3fxc8b" />
      </div>

      <span className="pointer-events-none absolute left-3 top-3 rounded-full bg-navy/80 px-3 py-1 font-display text-xs font-bold text-white" data-id="element-40" data-mp="1nms11eshnxom">
        {beforeLabel}
      </span>
      <span className="pointer-events-none absolute right-3 top-3 rounded-full bg-bright px-3 py-1 font-display text-xs font-bold text-white" data-id="element-41" data-mp="18jrpozijoiv7">
        {afterLabel}
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white" style={{
      left: `${position}%`
    }} aria-hidden="true" data-id="element-42" data-mp="1iifv8ytcf5i0">
        <span className="absolute left-1/2 top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white shadow-lift" data-id="element-43" data-mp="1sad7m8w383ib">
          <MoveHorizontalIcon className="h-5 w-5 text-royal" aria-hidden="true" data-id="element-44" data-mp="1wdi680d1rl1o" />
        </span>
      </div>

      <input type="range" min={0} max={100} step={1} value={position} onChange={event => setPosition(Number(event.target.value))} aria-label={ariaLabel} className="absolute inset-0 h-full w-full cursor-col-resize appearance-none bg-transparent opacity-0" data-id="element-45" data-mp="218p4gsnjrxj7" />
    </div>;
}